import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, Spinner, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '../../../api/apiClient';

const StripeCancelPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get('paymentId');

  const [isProcessing, setIsProcessing] = useState(true);

  useEffect(() => {
    const markPaymentFailed = async () => {
      if (!paymentId) {
        setIsProcessing(false);
        toast.error('Unable to identify the cancelled payment.');
        return;
      }

      try {
        await api.payments.cancelStripe({ paymentId });
        toast.info('Stripe payment was cancelled.');
      } catch (error) {
        console.error('Failed to mark payment as cancelled', error);
      } finally {
        setIsProcessing(false);
      }
    };

    markPaymentFailed();
  }, [paymentId]);

  if (isProcessing) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="secondary" />
        <p className="text-muted mt-3 mb-0">Processing cancellation...</p>
      </div>
    );
  }

  return (
    <Card className="border-0 shadow-sm">
      <Card.Body className="p-4 text-center">
        <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-warning bg-opacity-10 mb-3" style={{ width: '96px', height: '96px' }}>
          <i className="fas fa-exclamation text-warning" style={{ fontSize: '38px' }}></i>
        </div>
        <h4 className="fw-bold text-dark">Payment Cancelled</h4>
        <p className="text-muted mb-4">
          The Stripe checkout was cancelled. You can return to your cart and try again whenever you're ready.
        </p>
        <div className="d-flex flex-column flex-md-row justify-content-center gap-3">
          <Button variant="success" onClick={() => navigate('/user/payment/select')}>
            <i className="fas fa-redo me-2"></i>
            Resume Checkout
          </Button>
          <Button variant="outline-secondary" onClick={() => navigate('/user/cart')}>
            <i className="fas fa-shopping-cart me-2"></i>
            Back to Cart
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default StripeCancelPage;

